export enum SprayRecordSearchBy {
  Name,
  SprayRecordNumberId,
  FarmId,
  DateRange,
  Report,
  Status,
  Activity,
  Supervisor,
  Employee,
  MasterRecordId,
  General,
  All,
}
